<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <div #studentHeader style="padding:10px;">
        <student-header [pageTitle]="'Transportation'" [showYearSelector]="true" [disableYearSelect]="versatransEnabled" ></student-header>
    </div>
    <div class="flex-content"> 
        <table style="width:100%;" *ngIf="transportation.length > 0 && (versatransEnabled || !v10)">
            <tr *ngIf="transportation[0].ProgramName != ''">
                <td style="color:gray;padding-left:20px;width:150px;" translate>Program</td>
                <td>{{transportation[0].ProgramName}}</td>
            </tr>
        </table>   
        <div id="Message" *ngIf="transportation.length == 0 && !showErrorMessage && !isBusy" style="text-align:center;vertical-align:middle;padding-top:50px;" translate>
            No transportation data exists for student.
        </div>
        <div *ngIf="showErrorMessage" style="text-align:center;vertical-align:middle;padding-top:50px;" translate>
            <span *ngIf="errorMessage == ''">No transportation data is currently available.</span>
            <span *ngIf="errorMessage != ''">{{errorMessage}}</span>
        </div>
        <div style="height:100%; overflow:auto;flex-grow:1;" *ngIf="transportation.length > 0">
            <!-- Angular Material table definition -->
            <mat-table  *ngIf="versatransEnabled || !v10 || traversaEnabled">
                <!-- Individual column definitions -->
                <ng-container matColumnDef="More">
                    <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;"></mat-header-cell>
                </ng-container>
                <ng-container matColumnDef="Days">
                    <mat-header-cell *matHeaderCellDef>
                        <span></span>                            
                    </mat-header-cell>
                </ng-container>
                <ng-container matColumnDef="Destination">
                    <mat-header-cell *matHeaderCellDef>
                        <span></span>                            
                    </mat-header-cell>
                </ng-container>
                <ng-container matColumnDef="PickUp">
                    <mat-header-cell *matHeaderCellDef class="topBorder leftBorder">
                        <span></span>                            
                    </mat-header-cell>
                </ng-container>
                <ng-container matColumnDef="PickUpLocation">
                    <mat-header-cell *matHeaderCellDef class="topBorder" style="display:flex; justify-content:center;">
                        <span style="padding-right: 60px;display:flex;align-self: center;" translate>Pick Up</span>
                    </mat-header-cell>
                </ng-container>
                <ng-container matColumnDef="PickUpBus">
                    <mat-header-cell *matHeaderCellDef class="topBorder rightBorder">
                        <span>  </span>                            
                    </mat-header-cell>
                </ng-container>
                <ng-container matColumnDef="DropOff">
                    <mat-header-cell *matHeaderCellDef class="topBorder">
                        <span></span>                            
                    </mat-header-cell>
                </ng-container>
                <ng-container matColumnDef="DropOffLocation">
                    <mat-header-cell *matHeaderCellDef class="topBorder" style="display:flex; justify-content:center;">
                        <span style="padding-right: 60px;display:flex;align-self: center;" translate>Drop Off</span>
                    </mat-header-cell>
                </ng-container>
                <ng-container matColumnDef="DropOffBus">
                    <mat-header-cell *matHeaderCellDef class="topBorder rightBorder">
                        <span></span>                            
                    </mat-header-cell>
                </ng-container>
        
                <!-- Header row -->
                <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" style="border-bottom-width: 0px;max-height: 30px;">  </mat-header-row>   
            </mat-table>
            <mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSortDisableClear *ngIf="versatransEnabled || !v10 || traversaEnabled"
                    matSort id="TranDataTable"  matSortActive="Days" matSortDirection="desc" aria-label="Transportation Table" tabindex="0">
                <!-- Individual column definitions -->
                <ng-container matColumnDef="More">
                    <mat-header-cell #more *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;" translate class="removeTopPadding">More</mat-header-cell>
                    <mat-cell *matCellDef="let Trans" style="min-width:68px;max-width:68px;text-align:center;">
                        <span aria-label="Expand row for more details">
                            <i [ngClass]="checkExpanded(Trans) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" aria-hidden="true"></i>
                        </span>
                    </mat-cell>  
                </ng-container>
                <ng-container matColumnDef="Days">
                    <mat-header-cell #days *matHeaderCellDef mat-sort-header class="removeTopPadding">
                        <span translate>Days</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans">{{Trans.Days}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="Destination">
                    <mat-header-cell #destination *matHeaderCellDef mat-sort-header class="removeTopPadding">
                        <span translate>Destination</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans" >{{Trans.Destination}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="PickUp">
                    <mat-header-cell #pickUpTime *matHeaderCellDef mat-sort-header class="leftBorder removeTopPadding">
                        <span translate>Time</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans">
                        <!-- <span *ngIf="traversaEnabled">{{Trans.PickUp | date: 'hh:mm'}}</span>
                        <span *ngIf="!traversaEnabled">{{Trans.PickUp}}</span> -->
                        <span>{{Trans.PickUp}}</span>
                    </mat-cell>  
                </ng-container>
                <ng-container matColumnDef="PickUpLocation">
                    <mat-header-cell #pickUpLocation *matHeaderCellDef mat-sort-header class="removeTopPadding">
                        <span translate>Location</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans">{{Trans.PickUpLocation}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="PickUpBus">
                    <mat-header-cell #pickUpBus *matHeaderCellDef mat-sort-header class="rightBorder removeTopPadding">
                        <span translate>Bus</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans">
                            <span>{{Trans.PickUpBus}}</span>
                    </mat-cell>  
                </ng-container>
                <ng-container matColumnDef="DropOff">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="removeTopPadding">
                        <span translate>Time</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans">
                        <!-- <span *ngIf="traversaEnabled">{{Trans.DropOff | date: 'hh:mm'}}</span>
                        <span *ngIf="!traversaEnabled">{{Trans.DropOff}}</span> -->
                        <span>{{Trans.DropOff}}</span>
                    </mat-cell>  
                </ng-container>
                <ng-container matColumnDef="DropOffLocation">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="removeTopPadding">
                        <span translate>Location</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans">{{Trans.DropOffLocation}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="DropOffBus">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="rightBorder removeTopPadding">
                        <span translate>Bus</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans">{{Trans.DropOffBus}}</mat-cell>  
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                    <!-- Detail row can have standard html or another Angular Material table -->
                    <td mat-cell *matCellDef="let Trans" [attr.colspan]="columnsToDisplay.length"
                            style="width:100%;overflow: visible;" class="mat-detail-card">
                        <div style="width:100%;" [ngStyle]="{'padding-left': detailPadding + 'px'}">
                            <table style="width:100%;" aria-label="Transportation Details Table" tabindex="-1">
                                <tr style="line-height:normal;" tabindex="-1">
                                    <td style="color:gray;width: 125px;min-width: 125px;" translate>Pick Up Route</td>
                                    <td style="min-width: 225px;" [ngStyle]="{'width': pickUpPadding + 'px'}">{{Trans.PickUpRoute}}</td>
                                    <td style="color:gray;width: 125px;min-width: 125px;" translate>Drop Off Route</td>
                                    <td style="min-width: 225px;" [ngStyle]="{'width': pickUpPadding + 'px'}">{{Trans.DropOffRoute}}</td>
                                </tr>
                            </table>
                        </div>
                    </td>
                </ng-container>
        
                <!-- Row definitions determine what will actually be displayed -->
                <!-- Styles set here will apply to all cells in the row -->
                <!-- Header row -->
                <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" style="padding-top: 0px !important;" id = "TranDataHeader">            
                </mat-header-row>   
                <!-- Data rows -->
                <mat-row    *matRowDef="let row; columns: columnsToDisplay; let i = index;" 
                            id = "TranDataRow{{i}}"
                            tabindex="0"
                            [attr.aria-label]="getAriaRow(row)"
                            [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}" 
                            style="padding:0px;overflow: hidden;"
                            matRipple
                            (click)="toggleExpanded(row)"
                            (keydown)="rowKeyPress($event, row)">
                </mat-row>
                <!-- Detail row -->
                <!-- 'overflow: hidden' is required for animation to render properly -->
                <mat-row *matRowDef="let row; columns: ['expandedDetail']" 
                        [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'"
                        style="overflow: hidden;" class="mat-detail-row">
                </mat-row>
            </mat-table>
            <mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSortDisableClear *ngIf="!versatransEnabled && v10 && !traversaEnabled"
                    matSort id="TranNativeDataTable"  matSortActive="Destination" matSortDirection="desc" aria-label="Transportation Table" tabindex="0">
                <!-- Individual column definitions -->
                <ng-container matColumnDef="Destination">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
                        <span translate>Address</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans" style="min-width:100px;">{{Trans.Destination}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="AddressType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:150px;" >
                        <span translate>Address Type</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans" style="min-width:100px;max-width:150px;">{{Trans.AddressType}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="InBoundBus">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:125px;" >
                        <span translate>In Bound Bus</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans" style="min-width:100px;max-width:125px;">{{Trans.InBoundBus}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="InBoundRoute">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:150px;" >
                        <span translate>In Bound Route</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans" style="min-width:100px;max-width:150px;">{{Trans.InBoundRoute}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="InBoundStop">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:200px;max-width:350px;" >
                        <span translate>In Bound Stop</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans" style="min-width:200px;max-width:350px;">{{Trans.InBoundStopID}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="InBoundStopTime">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:150px;" >
                        <span translate>In Bound Stop Time</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans" style="min-width:100px;max-width:150px;">{{Trans.InBoundStopTime}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="OutBoundBus">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:125px;" >
                        <span translate>Out Bound Bus</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans" style="min-width:100px;max-width:125px;">{{Trans.OutBoundBus}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="OutBoundRoute">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:150px;" >
                        <span translate>Out Bound Route</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans" style="min-width:100px;max-width:150px;">{{Trans.OutBoundRoute}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="OutBoundStop">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:200px;max-width:350px;" >
                        <span translate>Out Bound Stop</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans" style="min-width:200px;max-width:350px;">{{Trans.OutBoundStopID}}</mat-cell>  
                </ng-container>
                <ng-container matColumnDef="OutBoundStopTime">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:175px;" >
                        <span translate>Out Bound Stop Time</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let Trans" style="min-width:100px;max-width:175px;">{{Trans.OutBoundStopTime}}</mat-cell>  
                </ng-container>    
                <!-- Row definitions determine what will actually be displayed -->
                <!-- Styles set here will apply to all cells in the row -->
                <!-- Header row -->
                <mat-header-row *matHeaderRowDef="columnsToDisplayTyler; sticky: true" id = "TranDataHeader">            
                </mat-header-row>   
                <!-- Data rows -->
                <mat-row    *matRowDef="let row; columns: columnsToDisplayTyler; let i = index;" 
                            id = "TranDataRow{{i}}"
                            tabindex="0"
                            [attr.aria-label]="getAriaRow(row)"
                            style="padding:0px;overflow: hidden;"
                            matRipple>
                </mat-row>
            </mat-table>
        </div>        
    </div>
</tyl-kendo-pdf-export>
<div #footer class="flex-footer">         
    <div class="flex-footer-left" *ngIf="(transportation.length > 0) && (versatransEnabled || !v10 || showTraversaBusRoute)">
        <tyl-button image="Expand All.png" label="Expand All" (clickEvent)="expandAll(true)" style="padding-left: 10px;"></tyl-button>
        <tyl-button image="Collapse All.png" label="Collapse All" (clickEvent)="expandAll(false)"></tyl-button>
    </div>
</div>

